import { gql } from "@grandvisionhq/graphql";
const ACTIVATE_SOCIAL_ACCOUNT = gql`
  mutation activateSocialAccount {
    activateSocialAccount {
      mergeableAccounts {
        email
        id
      }
    }
  }
`;
export {
  ACTIVATE_SOCIAL_ACCOUNT
};
//# sourceMappingURL=activate-social-account.js.map
